<template>
  <section ref="section" class="-visibility-auto">
    <div class="container">
      <Observer name="fade-up" @enter="enter">
        <div class="row justify-content-center">
          <div class="col-12 col-md-6 col-lg-5 text-center">
            <i :class="`icon-${item.icon}`" v-if="item.icon"></i>
            <h2 class="-upper title" v-if="item.title" v-text="item.title" aria-hidden="true"></h2>
            <div class="wysiwyg" v-if="item.text" v-html="item.text"></div>
            <SoundButton v-if="item.buttonAudio" :audio="item.buttonAudio" :text="item.buttonText" :title="item.buttonTitle" />
            <router-link v-if="item.ctaText && item.ctaLink" :to="localizedUrl + item.ctaLink" class="link-light">
              <span aria-hidden="true">{{ item.ctaText }}</span>
            </router-link>
          </div>
          <div :class="movementClasses">
            <div v-if="hasMultipleImages" ref="movements" class="movements-items">
              <button v-for="(movement, i) in item.images" :key="movement.title + '_' + i" class="movement-item" type="button" @click="selectedMovement = i" :class="{'-active': selectedMovement === i}">
                <lazy-picture :item="movement" desktop-ratio="1" mobile-ratio="1"></lazy-picture>
              </button>
            </div>
            <lazy-picture v-if="!hasMultipleImages" :item="item.images[0]" ref="picture" sizes="(max-width: 768px) 100vw, 50vw"></lazy-picture>
          </div>
        </div>
      </Observer>
    </div>
  </section>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { ReadyHook } from 'vue-asyncready'
import ImageManager from 'vue-storefront-prismic-ssr/utilities/ImageManager'
import LazyPicture from './utils/LazyPicture'
import SoundButton from './SoundButton'

export default {
  props: ['item', 'pagePosition', 'siblings-components'],
  name: 'Movement',
  mixins: [ReadyHook],
  components: {
    LazyPicture,
    SoundButton
  },
  data () {
    return {
      appeared: false,
      hasMultipleImages: this.item.images.length > 1,
      selectedMovement: 0
    }
  },
  computed: {
    localizedUrl () {
      return currentStoreView().url || ''
    },
    imageUrl () {
      return this.item.image.url
    },
    imageLowDefinition () {
      return ImageManager.getLowDefinition(this.imageUrl, 400, 1)
    },
    movementClasses () {
      return {
        'col-12 col-md-6 offset-lg-1 col-lg-5': !this.hasMultipleImages,
        'col-12 col-md-6 col-lg-7': this.hasMultipleImages
      }
    }
  },
  methods: {
    enter () {
      if (!this.appeared) {
        this.$refs.section.classList.remove('-visibility-auto')
        this.appeared = true
        if (this.$refs.picture) {
          this.$refs.picture.srcset = ImageManager.getSrcSet(this.imageUrl, 1200, 400, 100, 1)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~theme/css/core";

.-icons .title {
  display: inline;
  color: var(--zenith-white) !important;
  background: var(--zenith-theme-primary) !important;
  box-shadow: -2px 0px 0px 6px var(--zenith-theme-primary);
}

section {
  position: relative;
  overflow: hidden;
  background: #F8F8F8;

  .container {
    padding-top: 10rem;
    padding-bottom: 10rem;

    @include bp(max md) {
      padding-top: 6rem;
      padding-bottom: 6rem;
    }
  }

  .obs-fade-up {
    transition: none;
    opacity: 1;
    transform: none;

    .h4, .h6, .btn {
      transform: translateY(8rem);
      opacity: 0;
    }
  }

  .h4 {
    @include appear();
    color: var(--zenith-theme-primary);
  }

  .h6 {
    @include appear(200ms);
    color: var(--zenith-theme-primary);
  }

  .btn {
    @include appear(400ms);
  }
}

.col-12 {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 0 4rem;

  @include bp(max md) {
    min-height: auto;
    padding: 2rem 2rem;
  }

  h2, h3 {
    display: block;
    margin-bottom: 2rem;
  }

  i {
    font-size: em(24);
    margin-bottom: 2rem;
  }

  .wysiwyg {
    color: var(--zenith-component-text);

    /deep/ p {
      margin-bottom: 2rem;
      color: var(--zenith-theme-primary);
    }

    /deep/ a {
      color: var(--zenith-theme-primary);
      text-decoration: underline;
    }
  }

}

.sound-button {
  margin-top: 5rem;
}

.movements-items {
  display: flex;
  position: relative;
  margin: 0;
  height: auto;

  .movement-item {
    border: none;
    background: none;
    outline: none;
    padding: 0;

    /deep/ img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
        transform: scale(0.8);
        transition: transform 0.2s ease-in-out;
      }

    &.-active {
      /deep/ img {
        transform: scale(1.2);
      }
    }
  }
}

</style>
